import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const skillCategories = [
  {
    row: 1,
    items: [
      { "course-name": "Others", skill_count: 5 },
      { "course-name": "Job Application Guides", skill_count: 13 },
      { "course-name": "Film Making", skill_count: 13 },
      { "course-name": "Hardware and Network Security", skill_count: 14 },
      { "course-name": "Finance & Investments", skill_count: 20 },
      { "course-name": "Development Tools and No Code", skill_count: 19 },
      { "course-name": "Operating System and Databases", skill_count: 14 },
      { "course-name": "Web 3", skill_count: 2 },
    ],
  },
  {
    row: 2,
    items: [
      { "course-name": "Cloud Computing", skill_count: 14 },
      { "course-name": "Music", skill_count: 12 },
      { "course-name": "Design, Art & Tools", skill_count: 49 },
      { "course-name": "Data Science & Analytics", skill_count: 44 },
      { "course-name": "Digital Marketing", skill_count: 37 },
      { "course-name": "Business & Management", skill_count: 43 },
      { "course-name": "UI/UX", skill_count: 11 },
      { "course-name": "Programming", skill_count: 92 },
    ],
  },
];

const MoreThanSkills = () => {
  const slider1Ref = useRef(null);
  const slider2Ref = useRef(null);

  // Settings for the first slider (left to right)
  const sliderSettings1 = {
    dots: false,
    infinite: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
    touchMove: false,
    draggable: false,
  };

  // Settings for the second slider (right to left)
  const sliderSettings2 = {
    dots: false,
    infinite: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    swipe: false,
    touchMove: false,
    draggable: false,
    rtl: true,
  };

  useEffect(() => {
    // Start autoplay manually if needed
    if (slider1Ref.current) {
      slider1Ref.current.slickPlay();
    }
    if (slider2Ref.current) {
      slider2Ref.current.slickPlay();
    }
  }, []);

  return (
    <>
      <style jsx>{`
        .skills-slider .slick-track {
          display: flex !important;
          align-items: center;
        }
        .skills-slider .slick-slide {
          height: auto;
        }
        .skills-slider .slick-slide > div {
          height: 100%;
          padding: 0 4px;
        }
        .skills-slider .slick-list {
          overflow: visible !important;
        }
      `}</style>
      <section className="relative mx-auto mt-[44px] flex w-full flex-col items-center gap-6 overflow-hidden rounded-[24px] bg-[#062E53] py-6 px-4 md:mt-[90px] md:gap-8 md:py-6 md:px-10">
      <header className="relative w-full px-4 text-center text-lg leading-[25.2px] tracking-[0] [font-family:'Inter',Helvetica] md:text-[18px]">
        <span className="font-normal text-[#ABCAF1]">More Than </span>
        <span className="font-extrabold text-white">210+ </span>
        <span className="font-normal text-[#ABCAF1]">
          Skill Categories To Match Your Career Goal
        </span>
      </header>

      <div className="relative flex w-full flex-col items-start gap-4 overflow-hidden">
      <div className="w-[80px] z-[9999999] h-full absolute top-0 left-0" style={{
    background: "linear-gradient(to right, #062E53 0%, rgba(2, 38, 68, 0) 100%)",
  }}></div>
  <div className="w-[100px] z-[99999] h-full absolute top-0 -right-4 rotate-180" style={{
    background: "linear-gradient(to right, #062E53 0%, rgba(2, 38, 68, 0) 100%)",
  }}></div>
        <Slider 
          ref={slider1Ref}
          {...sliderSettings1}
          className="skills-slider"
        >
          {[...skillCategories[0].items, ...skillCategories[0].items, ...skillCategories[0].items]?.map(
            (item, index) => (
              <div key={`row1-${index}`} style={{ width: 'auto' }}>
                <div className="inline-flex h-full items-center gap-2">
                  <div
                    className="h-full rounded-[20px] p-[1.5px]"
                    style={{
                      background: `radial-gradient(
    ellipse 50% 80% at center,
    rgba(64, 106, 255, 1) 0%,
    rgba(64, 106, 255, 0.2) 100%
  )`,
                    }}
                  >
                    <div className="inline-flex h-full flex-col items-center justify-center gap-2 rounded-[20px] border-0 bg-[#032E4F] px-4 py-2.5 backdrop-blur-[3.5px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(3.5px)_brightness(100%)]">
                      <div className="flex w-full flex-col items-center gap-2 p-0 leading-none">
                        <div className="relative w-fit bg-[linear-gradient(180deg,#FFFFFF_42%,#87B4FF_100%)] bg-clip-text text-[16px] font-medium text-transparent">
                          {item?.["course-name"]}
                        </div>
                        {item?.skill_count && (
                          <div className="relative flex w-full flex-col items-center justify-center gap-2 self-stretch">
                            <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[12px] font-normal leading-3 tracking-[0] text-[#ffffff]/50 [font-family:'Inter',Helvetica]">
                              {item?.skill_count}+ Courses
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <img
                    className="relative h-6 w-6"
                    alt="Star"
                    src="https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Star%2020.png"
                  />
                </div>
              </div>
            )
          )}
        </Slider>

        <Slider 
          ref={slider2Ref}
          {...sliderSettings2}
          className="skills-slider"
        >
          {[...skillCategories[1].items, ...skillCategories[1].items, ...skillCategories[1].items]?.map(
            (item, index) => (
              <div key={`row2-${index}`} style={{ width: 'auto' }}>
                <div className="inline-flex h-full items-center gap-2">
                  <div
                    className="h-full rounded-[20px] p-[1.5px]"
                    style={{
                      background: `radial-gradient(
    ellipse 50% 80% at center,
    rgba(64, 106, 255, 1) 0%,
    rgba(64, 106, 255, 0.2) 100%
  )`,
                    }}
                  >
                    <div className="inline-flex h-full flex-col items-center justify-center gap-2 rounded-[20px] border-0 bg-[#032E4F] px-4 py-2.5 backdrop-blur-[3.5px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(3.5px)_brightness(100%)]">
                      <div className="flex w-full flex-col items-center gap-2 p-0 leading-none">
                        <div className="relative w-fit bg-[linear-gradient(180deg,#FFFFFF_42%,#87B4FF_100%)] bg-clip-text text-[16px] font-medium text-transparent">
                          {item?.["course-name"]}
                        </div>
                        {item?.skill_count && (
                          <div className="relative flex w-full flex-col items-center justify-center gap-2 self-stretch">
                            <div className="relative mt-[-1.00px] w-fit whitespace-nowrap text-[12px] font-normal leading-3 tracking-[0] text-[#ffffff]/50 [font-family:'Inter',Helvetica]">
                              {item?.skill_count}+ Courses
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <img
                    className="relative h-6 w-6"
                    alt="Star"
                    src={
                      "https://storage.googleapis.com/learntube-web-assets/files/LandingPage-2025/Star%2020.png"
                    }
                  />
                </div>
              </div>
            )
          )}
        </Slider>
        </div>
      </section>
    </>
  );
};

export default MoreThanSkills;
